(function () {
  const CLIPS = {
    up: {
      hidden: "polygon(0% 100%, 100% 100%, 100% 220%, 0% 220%)",
      visible: "polygon(0% 0%, 100% 0%, 100% 120%, 0% 120%)",
    },
    down: {
      hidden: "polygon(0% -120%, 100% -120%, 100% 0%, 0% 0%)",
      visible: "polygon(0% -20%, 100% -20%, 100% 100%, 0% 100%)",
    },
  };

  const REVEAL_DUR = 1.4;
  //let STEP = 2;

  const initMediaBanner = (section) => {
    if (!section || !section.classList.contains("media-banner-section")) {
      return;
    }

    if (typeof gsap === "undefined") {
      return;
    }

    const STEP = Number(
      section
        .querySelector(".media-banner")
        .getAttribute("data-animation-duration")
    );

    section
      .querySelectorAll(".media-banner-images-wrapper")
      .forEach((wrapper) => {
        const dir =
          (
            wrapper.getAttribute("data-animation-direction") || "up"
          ).toLowerCase() === "down"
            ? "down"
            : "up";
        const CLIP_HIDDEN = CLIPS[dir].hidden;
        const CLIP_VISIBLE = CLIPS[dir].visible;

        const images = wrapper.querySelectorAll(".media-banner-image");
        const N = images.length;
        if (!N) return;

        const masks = Array.from(images).map((img) => {
          const mask = img.querySelector(".media-banner-image-mask") || img;
          gsap.set(mask, { clipPath: CLIP_HIDDEN });
          return mask;
        });

        const isEveryMaskHasPlaceholder = masks.every((item) =>
          [...item.children].every((el) => el.tagName === "svg")
        );

        if (N === 1) {
          gsap.set(masks[0], { clipPath: CLIP_VISIBLE });
          images[0].style.zIndex = "2";
          return;
        }

        if (isEveryMaskHasPlaceholder) {
          gsap.set(masks[0], { clipPath: CLIP_VISIBLE });
          images[0].style.zIndex = "2";
          for (let i = 1; i < N; i++) {
            images[i].style.zIndex = "0";
          }
          return;
        }

        const isPair = N === 2;
        const holdDuration = Math.max(0, (N - 1) * STEP - REVEAL_DUR);

        function showImage(index) {
          const mask = masks[index];
          const img = images[index];
          const prevIndex = (index - 1 + N) % N;
          const hidingIndex = (index - 2 + N) % N;

          images.forEach((el, i) => {
            if (i === index) el.style.zIndex = "2";
            else if (i === prevIndex) el.style.zIndex = "1";
            else if (i === hidingIndex) el.style.zIndex = "0";
            else el.style.zIndex = "0";
          });

          gsap.fromTo(
            mask,
            { clipPath: CLIP_HIDDEN },
            {
              clipPath: CLIP_VISIBLE,
              duration: REVEAL_DUR,
              ease: "power2.inOut",
              onComplete: () => {
                if (isPair) return;
                gsap.to(masks[prevIndex], {
                  clipPath: CLIP_HIDDEN,
                  duration: REVEAL_DUR,
                  ease: "power2.inOut",
                  delay: holdDuration,
                });
              },
            }
          );

          gsap.delayedCall(STEP, () => showImage((index + 1) % N));
        }

        showImage(0);
      });
  };

  initMediaBanner(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initMediaBanner(event.target);
  });
})();
